import React, { useEffect, useRef, useState } from 'react';
import { AlertCircle, CheckCircle2, RefreshCw } from 'lucide-react';
import { useNavigate } from 'react-router-dom';
import { consumeHandoffState } from '../features/session/pkce';
import { useEngineSession } from '../features/session/EngineSessionProvider';

const AuthCallbackPage: React.FC = () => {
  const navigate = useNavigate();
  const session = useEngineSession();
  const started = useRef(false);
  const [error, setError] = useState<string>();

  useEffect(() => {
    if (started.current) return;
    started.current = true;
    const fragment = new URLSearchParams(window.location.hash.replace(/^#/, ''));
    const code = fragment.get('code') || '';
    const state = fragment.get('state') || '';
    window.history.replaceState(null, '', '/auth/callback');
    const stored = consumeHandoffState(state);
    if (!code || !stored) {
      setError('连接信息已失效，请返回文档页重新发起连接。');
      return;
    }
    void session.exchangeHandoff(code, stored.verifier).then((returnPath) => {
      navigate(returnPath || stored.returnPath, { replace: true });
    }).catch((exchangeError) => {
      setError(exchangeError instanceof Error ? exchangeError.message : '账号连接失败，请重试。');
    });
  }, [navigate, session]);

  return (
    <section className="engine-app-callback-state" aria-live="polite">
      {error ? (
        <>
          <AlertCircle size={28} />
          <h1>没有完成连接</h1>
          <p>{error}</p>
          <button type="button" className="engine-app-secondary-button" onClick={() => navigate('/documents', { replace: true })}>返回文档</button>
        </>
      ) : session.status === 'authenticated' ? (
        <><CheckCircle2 size={28} /><h1>连接成功</h1><p>正在打开你的文档。</p></>
      ) : (
        <><RefreshCw className="engine-app-spin" size={28} /><h1>正在连接账号</h1><p>请不要关闭这个页面。</p></>
      )}
    </section>
  );
};

export default AuthCallbackPage;

